import React from 'react';
import {
  Button,
  FormWithRedirect,
  required,
  SaveButton,
  TextInput,
  useNotify,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconCancel from '@material-ui/icons/Cancel';

import IntegrationModal from './IntegrationModal';
import { apiPost } from '../brainApi';

const useStyles = makeStyles(() => ({
  dialogWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  labelMargin: {
    marginBottom: 10,
  },
}));

const SuggestForm = ({ closeModal }) => {
  const classes = useStyles();
  const notify = useNotify();
  const handleSubmit = async (values) => {
    apiPost('/integration-suggest', values).then(() => {
      notify('Thank you for your suggestion!');
      closeModal();
    });
  };
  return (
    <IntegrationModal closeModal={closeModal}>
      <FormWithRedirect
        resource="integration"
        record={{}}
        save={handleSubmit}
        render={(formProps) => (
          <>
            <DialogTitle>Suggest a new integration</DialogTitle>
            <DialogContent className={classes.dialogWrapper}>
              <TextInput
                source="name"
                className={classes.labelMargin}
                label="Service Name"
                validate={[required()]}
              />
              <TextInput
                source="url"
                className={classes.labelMargin}
                label="URL (optional)"
              />
              <TextInput
                source="notes"
                className={classes.labelMargin}
                label="Notes (optional)"
                multiline
                rows={2}
              />
            </DialogContent>
            <DialogActions>
              <Button label="ra.action.cancel" onClick={closeModal}>
                <IconCancel />
              </Button>
              <SaveButton
                label="Submit"
                handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                pristine={formProps.pristine}
                saving={formProps.saving}
              />
            </DialogActions>
          </>
        )}
      />
    </IntegrationModal>
  );
};

export default SuggestForm;
